import { microsecondsToTimestep, MID_FRAME_VIDEO_OFFSET_MICROSECONDS } from '../../utils/time.js';

/**
 * Used to filter by specific players
 *
 * @param {Array<number>} playerIds
 */
const bySelectedPlayers = (playerIds) => (track) => playerIds.includes(track.player.playerId);
/**
 * Map player tracks to ground positions for the current timestamp
 *
 * @param {Microsecond} currentTimestamp
 * @param {HomographyMatrix} H
 */
const toGroundPositionsForCurrentTime = (currentTimestamp, H) => ({ player, steps }) => {
    const step = steps.find(({ timestamp }) => timestamp === currentTimestamp);
    if (!(step === null || step === void 0 ? void 0 : step.ground)) {
        return []; // Return array so flatmap will filter this ground position out.
    }
    return {
        ...player,
        ...step.ground,
        h: H,
    };
};
/*
 *  Returns new homography matrix, removing the translation component from the original matrix
 *  while keeping the rotation and scaling intact.
 */
const getHWithoutTranslation = (h) => [
    [h[0][0], h[0][1], 0],
    [h[1][0], h[1][1], 0],
    [0, 0, 1],
];
/**
 * Adds PlayerMetaData (ie colour to display in the ground position)
 *
 * @param {PlayerMetaData[]} players
 */
const addPlayerMetaData = (players) => (playerTrack) => ({
    ...playerTrack,
    player: {
        ...playerTrack.player,
        ...(players.find(({ playerId }) => playerId === playerTrack.player.playerId) || {}),
    },
});
/**
 * Given the api response, format the data for the ground positions component for the current timestamp.
 *
 * @param {ApiResponse} data
 * @param {Microsecond} currentTimestamp
 * @param {Array<number>} players
 *
 * @returns {GroundPositions}
 */
const getGroundPositions = ({ playerTracks, homography }, currentTimestamp, players = []) => {
    var _a;
    const currentStep = microsecondsToTimestep(currentTimestamp + MID_FRAME_VIDEO_OFFSET_MICROSECONDS);
    const H = (_a = homography.find((h) => h.timestamp === currentStep)) === null || _a === void 0 ? void 0 : _a.H;
    const playerIds = players.map(({ playerId }) => playerId);
    return H
        ? playerTracks
            .filter(bySelectedPlayers(playerIds))
            .map(addPlayerMetaData(players))
            .flatMap(toGroundPositionsForCurrentTime(currentStep, getHWithoutTranslation(H)))
        : [];
};

export { getGroundPositions, getHWithoutTranslation };
//# sourceMappingURL=HighlightPlayerPositions.helper.js.map
